export function surveyListConfig(getMoney) {
    return {
        menuType: "button",
        addBtn: false,
        menuWidth: 120,
        menuAlign: "center",
        card: true,
        menu:false,
        delBtn: false,
        editBtn: false,
        align: "center",
        searchMenuSpan: 8,
        columnBtn: false,
        searchBtn: true,
        index: true,
        indexLabel: "序号",
        indexLabelWidth: 35,
        selection:true,
        selectionWidth:35,
        refreshBtn: true,
        showSummary: true,
        searchShow: false,
        border:true,
        sumColumnList: [
          {
            name: "factoringCredit",
            overHidden: true,
            type: "sum",
          }
        ],        
        column: [
            {
                label: '项目名称',
                searchPlaceholder: "请输入项目名称",
                placeholder: '请输入项目名称',
                prop: "name",
                slot: true,
                search: true,
                overHidden: true,
                width: '230'
            },{
              label: '客户名称',
              placeholder: '请输入客户名称',
              search: true,
              prop: "sellerCustName",
              width: '150',
              overHidden: true
            },{
                label: '项目编号',
                prop: "number",
                overHidden: true,
                width: "120"
            },
            {
                label: '保理类型',
                prop: "projectTypeStr",
                width: '150'
            },{
                label: '保理额度（元）',
                prop: "factoringCredit",
                width: "180",
                formatter: (row, value, label, column) => {
                    return `${getMoney(value)}元`;
                }
            },
            {
                label: '内部收益率',
                prop: "xirr",
                width: '150',
                formatter: (row, value, label, column) => {
                  return `${(Number(value)*100).toFixed(4)}%`;
                }
            },            
            {
              label: '业务主办',
              width: "120",
              prop: "managerUserName",
              overHidden: true,
            },{
              label: '业务协办',
              width: "120",
              prop: "assistUserName",
              overHidden: true,
            },
            {
                label: '所属部门',
                prop: "managerDeptName",
                overHidden: true,
                width: '150'
            },
            {
                label: '尽调状态',
                prop: "auditStatusStr",
                width: '150'
            },           
            {
              label: '尽调状态',
              prop: 'auditStatus',
              span: 12,
              hide: true,
              search: true,
              type: "select",
              dicUrl: "/api/blade-system/dict-biz/dictionary?code=project_build_state",
              props: {
                label: "dictValue",
                value: "dictKey"
              }
            }, 
            {
              label: '日期范围',
              prop: 'timePic',
              type:'daterange',
              searchSpan:12,
              searchRange:true,
              search:true,
              hide:true
            },           
            // {
            //     label: '买方',
            //     prop: "buyerCustName",
            //     overHidden: true,
            //     width: '150'
            // },
            // {
            //     label: '卖方',
            //     prop: "sellerCustName",
            //     search: true,
            //     searchslot: true,
            //     overHidden: true,
            //     width: '150'
            // },            
            {
                label: '保理商',
                prop: "accountingEntity",
                width: '180',
                overHidden: true,
                formatter: (row, value, label, column) => {
                  return `台金商业保理（天津）有限公司`;
                }
            },
            {
                label: '创建时间',
                width: "120",
                prop: "createTime",
                overHidden: true,
            }      
        ]
    }
}

export function filterConfig(selectPersonClick,selectDeptClick) {
  return {
    column: [
      {
        label: '项目名称',
        placeholder: '请输入项目名称',
        prop: "name"
      },{
        label: '客户名称',
        placeholder: '请输入客户名称',
        prop: "sellerCustName"        
      },{
        label: '业务经理',
        prop: 'managerUserName',
        click: () => {
          selectPersonClick();
        }        
      },{
        label: '所属部门',
        prop: 'managerDeptName',
        click: () => {
          selectDeptClick();
        }        
      },{
        label: '业务类型',
        prop: "factoringType",
        type: "select",
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=foctoring_business_type',
        props: {
          label: "dictValue",
          value: "dictKey"
        }
      },{
        label: "是否国有企业",
        prop: "isGoverCompany",
        type: "select",
        labelWidth: 110,
        dicData: [
          {
            label: "是",
            value: 1,
          },
          {
            label: "否",
            value: 0,
          },
        ],
        display: true,
        hide: true,
        hideshow: true,        
      },{
        label: "是否上市及其关联公司",
        labelWidth: 120,
        prop: "isGoPublic",
        type: "select",
        dicData: [
          {
            label: "是",
            value: 1,
          },
          {
            label: "否",
            value: 0,
          },
        ],
        display: true,
        hide: true,
        hideshow: true,        
      },{
        label: "是否新三板企业",
        labelWidth: 120,
        prop: "isNewThreeCompay",
        type: "select",
        dicData: [
          {
            label: "是",
            value: 1,
          },
          {
            label: "否",
            value: 0,
          },
        ],
        display: true,
        hide: true,
        hideshow: true,
      },{
        label: "是否瞪羚企业",
        labelWidth: 110,
        prop: "isGazelleCompany",
        type: "select",
        dicData: [
          {
            label: "是",
            value: 1,
          },
          {
            label: "否",
            value: 0,
          },
        ],
        display: true,
        hide: true,
        hideshow: true,        
      },{
        label: "客户类型",
        prop: "custType",
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=cust_type",
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        dataType: "number",
        display: true,
        hide: true,
        hideshow: true,        
      },{
        label: "企业规模",
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=enterprise_scale",
        prop: 'formEnterpriseScale',
        props: {
          label: "dictValue",
          value: "dictKey"
        }
      },{
        label: "所属行业",
        prop: "industry",
        disabled: true,
        alwaysDisabled: true,        
        // type: "cascader",
        // dicUrl: "/api/blade-system/dict-biz/industryType",
        // props: {
        //   label: "dictValue",
        //   value: "dictKey"
        // },
        // dataType: "string",
        width: "120"
      },{
        sortable: "custom",
        label: "融资额度",
        prop: "factoringCredit",
        formslot: true,        
      },{
        label: "内部收益率(%)",
        labelWidth: 120,
        prop: "benefitRate",
        display: true,
        formslot: true,        
      },{
        label: "尽调状态",
        prop: "flowState",
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=wf_state",
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        dataType: "string",        
      },{
        label: "审核状态",
        prop: "auditState",
        type: "select",
        search: true,
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=audit_state",
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        dataType: "string",      
      },{
        label: '创建时间',
        prop: 'createTime',
        type: 'datetime',
      }
    ]
  }
}

export function checkQuotaConfig() {
  return {
    labelWidth: 150,
    emptyBtn: false,
    emptyText: '取消',
    submitBtn: false,
    submitText: '确定',
    column: [
      {
        label: '是否按发起额度通过',
        prop: 'isCredit',
        type: 'radio',
        labelWidth: 180,
        span: 24,
        value:0,
        dicData: [{
          label: '否',
          value: '0'
        },{
          label: '是',
          value: '1'
        }],
        rules: [{
          required: true,
          message: "请选择",
          trigger: "change"
        }]
      },{
        label: '修改额度',
        prop: 'checkedCredit',
        append: '元',
        labelWidth: 180,
        span: 24,
        display: false,
        rules: [{
          required: true,
          message: "请输入修改额度",
          trigger: "blur"
        }]
      }
    ]
  }
}

export function addSurveyConfig() {
  return {
    labelWidth: 130,
    emptyBtn: false,
    submitBtn: false,
    column: [{
      label: "项目名称",
      prop: "name",
      formslot: true,
      disabled: false,
      placeholder: "等待生成项目名称",
    },{
      label: "保理类型",
      prop: "projectType",
      type: "select",
      disabled: false,
      dicUrl: '/api/blade-system/dict-biz/dictionary?code=foctoring_business_type',
      props: {
        label: "dictValue",
        value: "dictKey"
      },
      rules: [{
        required: true,
        message: "请选择保理类型",
        trigger: "change"
      }]      
    },{
      // 选择类型
      label: "卖方(债权人)",
      prop: "sellerCustId",
      disabled: false,
      dicUrl: '/api/blade-/zd/custom/dict',
      dicMethod:'post',
      dicQuery:{
        custType: 2
      },
      formslot: true,
      rules: [{
        required: true,
        message: "请选择卖方",
        trigger: "change"
      }]
    },{
      label: "买方(债务人)",
      prop: 'buyerCustName',
      disabled: false,
      rules: [{
        required: true,
        message: "请选择买方",
        trigger: "change"
      }]
    },
    // {
    //   label: '项目编号',
    //   prop: 'number',
    //   disabled: true
    // },{
    //   label: '业务主办',
    //   prop: 'managerUserName',
    //   alwaysDisabled: true,
    //   disabled: true
    // },{
    //   label: '业务协办',
    //   prop: 'assistUserName',
    //   disabled: true,
    //   alwaysDisabled: true,
    //   click: () => {
    //     selectPersonClick();
    //   }        
    // },
    {
      label: "项目来源",
      prop: "projectComeFrom",
      type: "select",
      disabled: false,
      dicUrl: '/api/blade-system/dict-biz/dictionary?code=project_source',
      props: {
        label: "dictValue",
        value: "dictKey"
      },
      rules: [{
        required: true,
        message: "请选择项目来源",
        trigger: "change"
      }]      
    },{
      label: '担保方式', 
      prop: 'guaranteeMethod',
      disabled: false,
      // type: "select",
      // dicUrl: '/api/blade-system/dict-biz/dictionary?code=factoring_guarantee_method',
      // props: {
      //   label: "dictValue",
      //   value: "dictKey"
      // },
      rules: [{
        required: true,
        message: "请输入担保方式",
        trigger: "blur" 
      }]
    },
    {
      label: '还款方式',
      prop: 'repaymentType',
      disabled: true,
      type: 'select',
      dicUrl: '/api/blade-system/dict-biz/dictionary?code=repayment_frequency',
      props: {
        label: "dictValue",
        value: "dictKey"
      },
      dataType:'string',
      value:'0',
      rules: [{
        required: true,
        message: "请选择还款方式",
        trigger: "blur" 
      }]
    },
    {
      label: '是否为保理池项目',
      prop: 'isBlPool',
      type: 'select',
      dicData: [
        {
         label:'是',
         value:1
        },
        {
          label:'否',
          value:0
         }
      ],
      disabled: false,
    },
    {
      label: '授信是否可循环',
      prop: 'isLoopCredit',
      disabled: false,
      type: 'select',
      dicUrl: '/api/blade-system/dict-biz/dictionary?code=factoring_loop_credit',
      props: {
        label: "dictValue",
        value: "dictKey"
      },      
      rules: [{
        required: true,
        message: "请选择授信是否可循环",
        trigger: "blur" 
      }]
    },{
      label: '申请额度',
      prop: 'factoringCredit',
      disabled: true,
      alwaysDisabled: true
    },{
      label: '核定额度',
      prop: 'checkedCredit',
      disabled: true,
      alwaysDisabled: true
    },{
      label: "报价方案",
      prop: "quotaPlan",
      formslot: true,
      span: 24,
      rules: [{
        required: true,
        message: "请选择报价方案",
        trigger: "blur" 
      }]      
    },
    {
      label: '特别操作说明',
      type: 'textarea',
      disabled: false,
      prop: 'remarks',
      span: 24
    }]
  }
}

export function extraForm() {
  return [
    {
      label: '项目编号',
      prop: 'number',
      span: '12'
    },{
      label: '所属部门',
      prop: "managerDeptName",
      span: '12'
    },{
      label: '业务主办',
      prop: "managerUserName",
      span: '12'
    },{
      label: '业务协办',
      prop: "assistUserName",
      span: '12'
    },{
      label: '融资额度',
      prop: "factoringCredit",
      span: '12',
      unit: '元'
    },{
      label: '保理融资期限',
      prop: "financingMaturity",
      span: '12',
      unit: '天'
    },{
      label: '保理转让款使用费率',
      prop: "annualInterestRateStr",
      unit: '%',
      span: '12'
    },{
      label: '内部收益率',
      prop: "xirrStr",
      unit: '%',
      span: '12'
    },{
      label: '逾期使用费率',
      prop: "overdueInterestRateStr",
      unit: '%',
      span: '12'
    },{
      label: '手续费',
      prop: "poundageStr",
      unit: '元',
      span: '12'
    },{
      label: '手续费收取方式',
      prop: "poundageChargeTypeStr",
      span: '12'
    },{
      label: '保证金',
      prop: "cashDepositStr",
      span: '12',
      unit: '元'
    },{
      label: '保证金收取方式',
      prop: "cashDepositReturnTypeStr",
      span: '12'
    },{
      label: '保证金归还方式',
      prop: "cashDepositChargeTypeStr",
      span: '12'
    },{
      label: '宽限期',
      prop: "gracePeriod",
      span: '12',
      unit: '天'
    },{
      label: '宽限期费率',
      prop: "graceRateStr",
      span: '12',
      // unit: '%'
    },{
      label: '担保方式说明',
      placeholder: '请输入担保方式',
      disabled: false,
      prop: 'introGuaranteeMethodExplain',
      type: 'input',
      span: '24'
    },
    {
      label: '租赁标的物',
      placeholder: '请输入租赁标的物',
      disabled: false,
      prop: 'introLeaseSubjectMatter',
      type: 'input',
      span: '24'
    },
    {
      label: '资金用途',
      placeholder: '请输入资金用途',
      disabled: false,
      prop: 'introFundsUse',
      type: 'input',
      span: '24'      
    },
    {
      label: '项目在建情况',
      placeholder: '请输入项目在建情况',
      disabled: false,
      prop: "introProjectState",
      type: 'input',
      span: '24'
    },
    // {
    //   label: '特别操作说明',
    //   placeholder: '请输入特别操作说明',
    //   disabled: false,
    //   prop: 'introSpecialOperation',
    //   type: 'input',
    //   span: '24'
    // },
    {
      label: '备注',
      placeholder: '请输入备注',
      disabled: false,
      prop: 'introRemark',
      type: 'textarea',
      span: '24'
    }
  ]
}

export function surveyProjectConfig() {
  return [
    {
      label: '融资额度(元)',
      prop: 'factoringCredit',
    },
    {
      label: '敞口金额',
      prop: 'finStandard',
    },
    {
      label: '租赁物风险敞口比率',
      prop: 'riskExposure',
    },
    {
      label: '租金计算方式',
      prop: 'calculateRentMethod',
    },
    {
      label: '租金还款频次',
      prop: 'repaymentFrequency',
    },
    {
      label: '还款期限',
      prop: 'financingMaturity'
    },
    {
      label: '手续费',
      prop: 'poundage'
    },
    {
      label: '手续费扣款方式',
      prop: 'poundageChargeTypeStr'
    },
    {
      label: '内部收益率',
      prop: 'xirrStr',
      unit: '%'
    },
    {
      label: '保证金',
      prop: 'cashDeposit',
    },
    {
      label: '保证金扣款方式',
      prop: 'cashDepositChargeTypeStr',
    },
    {
      label: '保证金退还方式',
      prop: 'cashDepositReturnTypeStr',
    },
    {
      label: '利率模式'
    },
    {
      label: '浮动方式'
    },
    {
      label: '名义货价'
    },
    {
      label: '担保方式'
    },
    {
      label: '担保方式说明',
      placeholder: '请输入担保方式',
      prop: 'introGuaranteeMethodExplain',
      type: 'input',
      span: '24'
    },
    {
      label: '租赁标的物',
      placeholder: '请输入租赁标的物',
      prop: 'introLeaseSubjectMatter',
      type: 'input',
      span: '24'
    },
    {
      label: '资金用途',
      placeholder: '请输入资金用途',
      prop: 'introFundsUse',
      type: 'input',
      span: '24'      
    },
    {
      label: '项目在建情况',
      placeholder: '请输入项目在建情况',
      prop: "introProjectState",
      type: 'input',
      span: '24'
    },
    {
      label: '特别操作说明',
      placeholder: '请输入特别操作说明',
      prop: 'introSpecialOperation',
      type: 'input',
      span: '24'
    },
    {
      label: '备注',
      placeholder: '请输入备注',
      prop: 'introRemark',
      type: 'textarea',
      span: '24'
    }
  ]
}

export function customerConfig() {
  return [
    {
      label: '客户名称',
      prop: 'custName',
      span: '12'
    },
    {
      label: '客户类别',
      prop: 'custCategory',
      span: '12',
      formatter: (label, value) => {
        let returnData = value == 1?'个人客户':value == 2?'机构客户':'无'
        return returnData
      }
    },
    {
      label: '客户来源',
      prop: 'custSourceStr',
      span: '12'
    },
    {
      label: '客户性质',
      prop: 'custAttributeStr',
      span: '12'
    },
    {
      label: '所属行业',
      prop: 'industryStr',
      span: '12'
    },
    {
      label: '企业类型',
      prop: 'enterpriseTypeStr',
      span: '12'
    },
    {
      label: '企业规模',
      prop: 'enterpriseScaleStr',
      span: '12'
    },
    {
      label: '统一社会信用代码',
      prop: 'unifiedSocialCreditCode',
      span: '12'
    },
    {
      label: '注册资本(万元)',
      prop: 'registeredCapital',
      span: '12'
    },
    {
      label: '成立时间',
      prop: 'fundingTime',
      span: '12'
    },
    {
      label: '联系电话',
      prop: 'contactNumber',
      span: '12'
    },
    {
      label: '注册地址',
      prop: 'registeredAddress',
      span: '12'
    },
    {
      label: '办公地址',
      prop: 'officeAddress',
      span: '12'
    },
    {
      label: '企业概况',
      prop: 'custCompanyState',
      disabled: false,
      placeholder: '请输入企业概况',
      type: 'textarea',
      span: '24'
    },
    {
      label: '主要产品及销售状况',
      prop: 'custProductSalesState',
      disabled: false,
      placeholder: '请输入主要产品及销售状况',
      type: 'textarea',
      span: '24'
    },
    {
      label: '资产负债情况',
      prop: 'custPropertyState',
      disabled: false,
      placeholder: '请输入资产负债情况',
      type: 'textarea',
      span: '24'
    },
    {
      label: '其他',
      prop: 'custOther',
      disabled: false,
      placeholder: '请输入',
      type: 'textarea',
      span: '24'
    },
  ]
}